import React from 'react'

export const PageLayout = ({ children }) => {
  return <main className="main-content page">{children}</main>
}
